<template>
    <div class="px-1">
        <div class="dataPalpations mt-2">Cargar datos Palpaciones</div>
            <div>
                <validation-observer ref="registerForm">
                    <b-form class="auth-register-form mt-2" @submit.prevent="validationForm">
                        <b-form-group >
                                Fecha       
                                <b-form-datepicker id="fecha_compra" name="fecha_compra" v-model="reproductive.date" 
                                :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                                :min="minCfgDate" :max="maxCfgDate"
                                locale="es-ES"/>                 
                        </b-form-group> 
                        <div class="d-flex">
                            <b-form-group label="Estado" label-for="state"  class="flex-fill" >
                                <b-form-select  id="state" v-model="reproductive.status" :options="stateOptions" :values="stateOptions.value" label="text"  />
                            </b-form-group>
                            <b-form-group label="Días de preñez:"  class="flex-fill ml-1" label-for="pregnancyDays"  v-if="reproductive.status==1">
                                <b-form-input  id="pregnancyDays" v-model="reproductive.days"   />
                            </b-form-group>
                        </div>
                        <div>
                            <b-form-group label="Seleccionar Vaca"  class="flex-fill" label-for="pregnancyDays"  >
                                    <b-form-select v-model="reproductive.animal_id" :options="animalsOptions"  :values="animalsOptions.value" label="text"  />
                            </b-form-group>
                        </div>
                    </b-form>
                </validation-observer>
                <div>
                    <b-form-group  label="Observaciones" label-for="textarea" class="mt-1">
                        <b-form-textarea  id="textarea" v-model="reproductive.details"  rows="5" class="flex-fill"
                                max-rows="6"></b-form-textarea>
                    </b-form-group>
                    <div class="d-flex align-items-center justify-content-center pbbuton">
                        <b-button
                            type="submit" v-on:click="insertReproductive"
                            class="bg-primary w-75 mt-2 "
                        >
                            Incluir Evento
                        </b-button>
                    </div>
                </div>
            </div>
        <ControlMenu />
    </div>
</template>



<script>
import ControlMenu from '@/components/ControlMenu.vue'
import vSelect from 'vue-select'
import "vue-select/dist/vue-select.css";
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { BRow, BCol, BFormGroup, BFormInput,BFormSelect, BForm, BImg, BButton, BFormTextarea,BFormDatepicker } from 'bootstrap-vue'
import { required } from '@validations'
import flatPickr from 'vue-flatpickr-component'

let self= this;

export default {
    components: {
        ControlMenu,
        flatPickr,
        BFormGroup,
        ValidationProvider,
        ValidationObserver,
        BFormGroup,
        BFormInput,
        BFormSelect,
        BFormDatepicker,
        BForm,
        required,
        vSelect,
        BImg,
        BButton,
        BFormTextarea,
        
    },
    data() {
        const now = new Date()
        const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
        // 15th two months prior
        const minDate = new Date(today)
        minDate.setMonth(minDate.getMonth() - 119)
        minDate.setDate(15)
        // 15th in two months
        const maxDate = new Date(today)
        maxDate.setMonth
        maxDate.setMonth(maxDate.getMonth())
        maxDate.setDate(maxDate.getDate())
        return {
            dateFormat:'%n/%Y',
            maxCfgDate:maxDate,
            minCfgDate:minDate,
            setLang:'es',
            animal_picker: null,
            condition:null,
            state:1,
            pregnancyDays:null,
            pregnancyOptions: [],
            stateOptions: [],
            animalsOptions:[],
            animals:[],
            reproductive:{
                farm_id: localStorage.getItem('currentFarm'),
                status:1,
                date:today,
                condition_id:1,
                type:6,
                animal_id:0,
                days:0,
                male_id:59,
                details:''
            }
        }
    },

    methods: {
        async fetchStatus(config) {
            fetch(this.$apiUrl+"list/reproductive_record_status", config)
            .then(response => response.json())
            .then(result => {
                this.stateOptions = result.reproductive_record_status.map(item => {return {text:item.name, value:item.id}})
            })
        },

        async fetchAnimals(config){
            let farmId= localStorage.getItem('currentFarm');
            let self=this;
            fetch(this.$apiUrl+"list/animals?farm_id="+farmId+"&sex=1&state=1", config)
            .then(response => response.json())
            .then(result => {
                console.log(result.animals);
                result.animals.forEach(function(row){
                    if(row.age>=15){
                        self.animalsOptions.push({value:row.id,text:row.number+ ' '+row.name})
                    }
                })
                //this.animalsOptions = result.animals.map(item => {return {value:item.id,text:item.number+ ' '+item.name}});
                console.log(this.animals);
            })
        },

        insertReproductive(){
            let self=this;
            console.log(this.reproductive);
            const token = localStorage.getItem("accessToken");
            const config = {headers: {"X-Authorization": `Bearer ${token}`}};
            this.$http.post("add/reproductive_records", this.reproductive, config).then(() => {
                if(self.reproductive.condition_id==1){
                    self.$http.post("edit/animals/"+self.reproductive.animal_id,{
                        pregnant:true
                    },config)
                    .then((result)=>{
                        console.log(result);
                    })
                }
                
                self.$swal({
                    title: 'Registro reproductivo',
                    text: 'Se insertó registro de palpación de manera satisfactoria',
                    type: 'success',
                    icon:'success',
                    showCancelButton: false,
                    confirmButtonColor:'#5E8F23',
                    showCloseButton: true,
                    showLoaderOnConfirm: false  
                }).then(function(){
                    history.back();
                });
            }).catch(error => {
                console.log(error)
            });
        }
    },
    watch:{
        'reproductive.status':function(value){
            console.log(value);
        }
    },
    created() {
        const token = localStorage.getItem("accessToken");
        const config = {headers: {"X-Authorization": `Bearer ${token}`}};
        this.fetchAnimals(config);
        this.fetchStatus(config);
    }
}
</script>
    

<style lang="scss">
.dataPalpations {

    font-family: 'Montserrat';
    font-style: normal;
    font-weight: 600;
    font-size: 24px;
    line-height: 29px;
    color: #5E5873;
}




@import '@core/scss/vue/libs/vue-flatpicker.scss';
@import '@core/scss/vue/pages/page-auth.scss';
</style>